import { BluxClient } from "../BluxClient";
import { EventRequest } from "../events/types";

export type BridgePlatform = "none" | "react-native" | "flutter";

export type BridgeAction =
  | "initialize"
  | "signIn"
  | "signOut"
  | "setUserProperties"
  | "setCustomUserProperties"
  | "sendEvent";

const _bridgePayloadMap = {
  initialize: { bluxApplicationId: "", bluxAPIKey: "" },
  signIn: {} as Parameters<BluxClient["signIn"]>[0],
  signOut: {},
  setUserProperties: {} as Parameters<
    BluxClient["setUserProperties"]
  >[0]["userProperties"],
  setCustomUserProperties: {} as Parameters<
    BluxClient["setCustomUserProperties"]
  >[0]["customUserProperties"],
  sendEvent: { requests: [] as EventRequest[] },
} satisfies Record<BridgeAction, unknown>;

export type BridgePayloadMap = typeof _bridgePayloadMap;

export type BridgePayload = BridgePayloadMap[keyof BridgePayloadMap];

export abstract class Bridge {
  abstract readonly platform: BridgePlatform;

  protected abstract postMessage(
    action: BridgeAction,
    payload?: BridgePayload,
  ): void;

  abstract initialize(payload: BridgePayloadMap["initialize"]): void;

  abstract signIn(payload: BridgePayloadMap["signIn"]): void;

  abstract signOut(): void;

  abstract setUserProperties(
    payload: BridgePayloadMap["setUserProperties"],
  ): void;

  abstract setCustomUserProperties(
    payload: BridgePayloadMap["setCustomUserProperties"],
  ): void;

  abstract sendEvent(payload: BridgePayloadMap["sendEvent"]): void;
}
